import { h } from "@stencil/core";
export class GxgStack {
    constructor() {
        this.space = "xs";
        this.columnsSpace = undefined;
    }
    el;
    render() {
        return h("slot", null);
    }
    componentWillLoad() {
        if (this.columnsSpace !== undefined) {
            this.assignColumnsSpace();
        }
    }
    assignColumnsSpace = () => {
        const gxgColumns = Array.from(this.el.querySelectorAll("gxg-columns"));
        gxgColumns.forEach((gxgColumn) => {
            gxgColumn.space = this.columnsSpace;
        });
    };
    static get is() { return "gxg-stack"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["stack.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["stack.css"]
        };
    }
    static get properties() {
        return {
            "space": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Space",
                    "resolved": "\"l\" | \"m\" | \"s\" | \"xl\" | \"xs\"",
                    "references": {
                        "Space": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/stack/stack.tsx",
                            "id": "src/components/stack/stack.tsx::Space"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The spacing value between each stack row"
                },
                "attribute": "space",
                "reflect": true,
                "defaultValue": "\"xs\""
            },
            "columnsSpace": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The spacing value between each gxg-column (if any present)"
                },
                "attribute": "columns-space",
                "reflect": true
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=stack.js.map
